import { InputSourceNode, MessagingTopology } from '@internal/open-catalog';
import { Box, Grid, IconButton, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../../../../components/accordion/accordion.styled';
import { InputSourceDialog } from './dialog.input.source';
import { usePanelEditableStyles } from './panel.style';

export function InputSourcePanel(props: {
  expanded: string | boolean,
  topology: MessagingTopology
  onAccordionStateChange: (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => void,
  onTopologyChange: (newNodeName?: string) => void
}) {

  const { topology, expanded, onAccordionStateChange, onTopologyChange } = props;

  const classes = usePanelEditableStyles();

  const [sources, setSources] = useState<InputSourceNode[]>([]);

  const [formDialog, setFormDialog] = useState(false);

  const openInputSourceFormDialog = (event: React.MouseEvent): void => {
    event.stopPropagation();
    setFormDialog(true);
  }

  const isDuplicatedInputSource = (newSource: InputSourceNode): boolean => {
    const found = topology.input?.sources.filter(src => src.name === newSource.name);
    return (found || []).length > 0;
  }

  const closeInputSourceFormDialog = (newSource?: InputSourceNode): void => {

    if (newSource && !isDuplicatedInputSource(newSource)) {
      topology.input?.sources.unshift(newSource);
      onTopologyChange(newSource.name);
    }
    setFormDialog(false);
  }

  const removeInputSource = (index: number): void => {
    topology.input?.sources.splice(index, 1);
    onTopologyChange();
  };

  useEffect(() => {
    setSources(topology.input?.sources || []);
  }, [topology]);

  return (<>
    
    {topology.input && (
      <InputSourceDialog open={formDialog} destination={topology.input}  environment={topology.vhost} onClose={closeInputSourceFormDialog} />
    )}
    
    <Accordion expanded={expanded === 'sources'} onChange={onAccordionStateChange('sources')}>
    
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <ListItem className={classes.headerWithActions}>
          <ListItemText primary="Sources" />
          <IconButton edge="start" color='secondary' size="small" title="Subscribe to external system service as source." onClick={openInputSourceFormDialog}>
            <AddIcon />
          </IconButton>
        </ListItem>
      </AccordionSummary>
      <AccordionDetails>

        {!sources.length && (
          <Typography variant='caption' component="p">No systems services as input sources defined, let's add some ! :D</Typography>
        )}

        {sources.length > 0 && (
          <Grid container spacing={1} className={classes.root}>
            {sources.map((p, index) => (
              <Grid key={index} item xs={12}>
                <Box className={classes.group}>
                  <List dense className={classes.list}>
                    <ListItem>
                      <ListItemText primary={p.name} secondary={p.type} title={p.name} />
                      <IconButton edge="start" size="small" title="Remove input source" onClick={() => removeInputSource(index)}>
                        <DeleteForeverIcon />
                      </IconButton>
                    </ListItem>
                  </List>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </AccordionDetails>
    </Accordion>
  </>);
};
